export const whatsAppLink =
  'https://api.whatsapp.com/send/?phone=79150667226&text&type=phone_number&app_absent=0';
